module.exports = __webpack_public_path__ + "static/img/Connor-Metcalfe.3d41f16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Connor-Metcalfe.jpg
// module id = aR9m
// module chunks = 0